import type { Asset } from '@passkeys/assets';
import { type CSSProperties } from 'react';

import TokenPickerButton, {
  TokenPickerButtonSkeleton,
} from '@/ui/components/token-picker-button';
import { cn } from '@/ui/utils/classnames';

export interface AssetButtonProps {
  asset: Asset;
  disabled?: boolean;
  noText?: boolean;
  className?: string;
  style?: CSSProperties;
  onPress: () => Promise<void>;
}

const AssetButton = ({
  asset,
  disabled,
  noText,
  className,
  style,
  onPress,
}: AssetButtonProps) => {
  return (
    <div className={cn('flex flex-col items-start', className)} style={style}>
      <TokenPickerButton
        selected={asset}
        disabled={disabled}
        noText={noText}
        onClick={onPress}
        withChainBadge
        dataTestId="asset-to-swap-button"
      />
    </div>
  );
};

export function AssetButtonSkeleton({
  noText,
  className,
}: Pick<AssetButtonProps, 'className' | 'noText'>) {
  return (
    <div className={cn('flex flex-col items-start', className)}>
      <TokenPickerButtonSkeleton noText={noText} />
    </div>
  );
}

export const DisabledAssetButton = (
  props: Omit<AssetButtonProps, 'disabled'>,
) => <AssetButton {...props} disabled />;
export const AssetButtonWithoutText = (
  props: Omit<AssetButtonProps, 'noText'>,
) => <AssetButton {...props} noText />;
export const DisabledAssetButtonWithoutText = (
  props: Omit<AssetButtonProps, 'disabled' | 'noText'>,
) => <AssetButton {...props} disabled noText />;

export default AssetButton;
